import {INotificationTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationTypeStrategy'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {
  INotificationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {IBrowserNotification} from '@toolify/client/src/stores/NotificationStore/types/IBrowserNotification'
import {getNotificationSoundUrl} from '@toolify/client/src/stores/NotificationStore/functions/getNotificationSoundUrl'
import {NotificationFilterType} from '@toolify/server/src/controllers/NotificationController/enum/NotificationFilterType'
import {i18n} from '@toolify/client/src/setup/i18n'
import {DefaultNotificationStrategy} from './DefaultNotificationStrategy'

const {t} = i18n.global

export class MentionedInDocumentNotificationStrategy extends DefaultNotificationStrategy<NotificationType.MentionedInDocument> implements INotificationTypeStrategy {
  getBrowserNotification(notification: INotificationResponseInstance<NotificationType.MentionedInDocument>, authorNick: string): IBrowserNotification {
    return {
      sound: getNotificationSoundUrl('new-notification.wav'),
      title: notification.payload.documentTitle || ENV.AppBrandingName,
      body: t('notifications.browserNotifications.mentionedInDocument', {author: authorNick}),
    }
  }

  getAffectedFilterTypes(notification: INotificationResponseInstance<NotificationType.MentionedInDocument>): NotificationFilterType[] {
    return [
      NotificationFilterType.All,
      NotificationFilterType.Unread,
      NotificationFilterType.Mentions,
    ]
  }
}
